<div class="content-overview">
  <ul
    ngbNav
    id="container"
    #nav="ngbNav"
    [(activeId)]="active"
    class="nav-tabs"
  >
    <li ngbNavItem="information">
      <a ngbNavLink class="fw-semi-bold">General informations</a>
      <ng-template ngbNavContent>
        <app-information [patientProfile]="patientProfile"></app-information>
      </ng-template>
    </li>
    <li ngbNavItem="medical">
      <a ngbNavLink class="fw-semi-bold">Medical folder</a>
      <ng-template ngbNavContent>
        <app-medical [patientProfile]="patientProfile"></app-medical>
      </ng-template>
    </li>
  </ul>
  <div [ngbNavOutlet]="nav" class="mt-2"></div>
</div>
